import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useInput, FieldTitle } from 'ra-core';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import TimePicker from '@mui/lab/TimePicker';
import DateTimePicker from '@mui/lab/DateTimePicker';

import DateFnsUtils from '@date-io/date-fns';

const Picker = ({ PickerComponent, ...props }) => {

  const {
    options,
    label,
    source,
    resource,
    className,
    isRequired,
    providerOptions,
  } = props;

  // const { input, meta } = useInput({ source });
  const {
            field,
            fieldState: { isTouched, invalid, error },
            formState: { isSubmitted }
        } = useInput(props);


  const handleChange = useCallback(value => {
    Date.parse(value) ? field.onChange(value.toISOString()) : field.onChange(null);
  }, []);

  return (
    <div className="picker">
      <LocalizationProvider {...providerOptions}>
        <PickerComponent
          {...field}
          {...options}
          label={<FieldTitle
            label={label}
            source={source}
            resource={resource}
            isRequired={isRequired}
          />}
          margin="normal"
          error={!!(isTouched && error)}
          helperText={isTouched && error}
          className={className}
          value={field.value ? new Date(field.value) : null}
          onChange={date => handleChange(date)}
          onBlur={() => field.onBlur(field.value ? new Date(field.value).toISOString() : null)}
        />
      </LocalizationProvider>
    </div>
  )
}

Picker.propTypes = {
  field: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  fieldState: PropTypes.object,
  formState: PropTypes.object,
  options: PropTypes.object,
  resource: PropTypes.string,
  source: PropTypes.string,
  labelTime: PropTypes.string,
  className: PropTypes.string,
  providerOptions: PropTypes.shape({
    utils: PropTypes.func,
    locale: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  }),
};

Picker.defaultProps = {
  // input: {},
  isRequired: false,
  // meta: { touched: false, error: false },
  options: {},
  resource: '',
  source: '',
  labelTime: '',
  className: '',
  providerOptions: {
    utils: DateFnsUtils,
    locale: undefined,
  },
};

export const DateInput = props => <Picker PickerComponent={DatePicker} {...props} />
export const TimeInput = props => <Picker PickerComponent={TimePicker} {...props} />
export const DateTimeInput = props => <Picker PickerComponent={DateTimePicker} {...props} />